module.exports = __webpack_public_path__ + "media/images/banner01-905e54f27091d7e0830a4d2049d605d1.webp";